module.exports = __webpack_public_path__ + "img/like_gif.0b9a4f3e.gif";